import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ModalService } from '../../../services/modal/modal.service';
import { ContentItem, DocumentContentItem } from 'app/shared/services/app/content/models';
import { ImageUploadService } from 'app/shared/services/image-upload/image-upload.service';
import { LoaderButton } from '../../loader-button/loader-button.component';
import { FileUploadComponent } from '../../file-upload/file-upload.component';

@Component({
  selector: 'tog-content-editor-document-modal',
  templateUrl: './content-editor-document-modal.component.html',
  styleUrls: ['./content-editor-document-modal.component.scss']
})
export class ContentEditorDocumentModalComponent implements OnInit {
  initialDocumentTitle: string = '';
  error: boolean = false;
  progressBarPercentage: number = 0;
  editMode: boolean = false;
  documentItem: DocumentContentItem;

  documentTitle: string = '';
  documentFile: File;

  @Input() app: string;
  @Output() documentChanged: EventEmitter<{ document: DocumentContentItem, isNew: boolean }> = new EventEmitter<{ document: DocumentContentItem, isNew: boolean }>();

  @ViewChild('saveDocumentButton') saveDocumentButton: LoaderButton;
  @ViewChild('fileUpload') fileUpload: FileUploadComponent;

  constructor(public modal: ModalService, public ius: ImageUploadService) { }

  ngOnInit() { }

  reset() {
    this.error = false;
    this.documentFile = null;
    this.documentTitle = '';
    this.initialDocumentTitle = '';
    this.progressBarPercentage = 0;
    this.saveDocumentButton.setInactive();
    this.fileUpload.resetForm();
  }

  show(document: DocumentContentItem = null) {
    this.reset();
    this.documentItem = document;
    if (document) this.editMode = true;
    if (document) {
      this.initialDocumentTitle = document.documentString;
      this.documentTitle = document.title;
    }
    this.modal.show('add-document-modal');
  }

  onDocumentChanged(e: any) {
    this.error = false;
    this.documentFile = e.file;
  }

  wrongFile(e: any) {
    setTimeout(() => {
      this.error = true;
    });
  }

  isDocumentButtonDisabled() {
    if (this.error) return true;
    else if (this.documentItem) return !this.documentTitle;
    else return (!this.documentFile || !this.documentTitle);
  }

  saveDocument() {
    if (this.documentFile) {
      // console.log(this.documentFile);
      let extensions = {
        'application/pdf' : 'pdf',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'xlsx'
      };
      this.ius.upload(this.app, this.documentFile, true, extensions[this.documentFile.type], this.documentFile.name)
      .then((url) => {
        if (this.documentItem) {
          this.documentItem.documentUrl = url; // must set url first
          this.documentItem.documentString = this.documentFile.name; // then the string, setUrl func in pdf-ConItem changes pdfstring
          this.documentItem.title = this.documentTitle;
          this.documentChanged.emit({ document: this.documentItem, isNew: false });
        } else {
          this.documentItem = new DocumentContentItem({
            url: url,
            title: this.documentTitle
          });
          this.documentItem.documentString = this.documentFile.name;
          this.documentItem.type = this.documentFile.type === 'application/pdf' ? 'pdf' : 'spreadsheet';
          this.documentChanged.emit({ document: this.documentItem, isNew: true });
        }
        this.saveDocumentButton.setConfirmed();
        this.modal.hide();
      });
    } else if (this.documentItem) {
      this.documentItem.title = this.documentTitle;
      this.documentChanged.emit({ document: this.documentItem, isNew: false});
      this.saveDocumentButton.setConfirmed();
      this.modal.hide();
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/content-editor/content-editor-document-modal/content-editor-document-modal.component.ts